import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

class Luntan extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        currentIndex: 0
    }

    setCurrentIndex = (index) => {
        const { content } = this.props;

        if (index > -1 && index < content.length) {
            this.setState({
                currentIndex: index
            });
        }
    }

    render() {
        const { content } = this.props;
        const { currentIndex } = this.state;

        return (
            <div className={styles.lunTan}>
                <div className={styles.swiper}>
                    <Swiper
                        modules={[Navigation]}
                        loop={true}
                        slidesPerView={3}
                        slideToClickedSlide={true}
                        navigation={{
                            prevEl: `.${styles.prev}`,
                            nextEl: `.${styles.next}`
                        }}
                        onSlideChange={(swiper) => {
                            this.setCurrentIndex(swiper.realIndex);
                        }}
                    >
                        {
                            content.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className={`${styles.swiperItem} ${currentIndex === index ? styles.active : ''}`}>
                                            <div className={styles.title}>
                                                {item.source}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })
                        }
                    </Swiper>
                    <img className={styles.prev} src="http://y0.ifengimg.com/314bd925cdd17196/2014/0228/btn05_l.gif" alt="" />
                    <img className={styles.next} src="http://y0.ifengimg.com/314bd925cdd17196/2014/0228/btn05_r.gif" alt="" />
                </div>
                <div className={styles.articles}>
                    <div className={styles.imagePart}>
                        <a href={content[currentIndex].url} target="_blank">
                            <img src={formatImage(getThumbnail(content[currentIndex]), 387, 343)} alt="" />
                            <div className={styles.alt}>{content[currentIndex].title}</div>
                        </a>
                    </div>
                    <div className={styles.articlePart}>
                        {
                            content[currentIndex].children && content[currentIndex].children.map((article, index) => {
                                return (
                                    <div className={styles.article} key={index}>
                                        <h5>
                                            <a href={article.url} target="_blank" rel="noreferrer">{article.title}</a>
                                        </h5>
                                        <p>
                                            {article.summary}
                                            <span className={styles.cRed}><a href={article.url} target="_blank" rel="noreferrer">[详细]</a></span>
                                        </p>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Luntan;
